import { useEffect, useState } from "react";
import api from "../api";

const itDT = (iso) => {
  if (!iso) return "—";
  const d = new Date(String(iso).replace(/(\.\d{3})\d+/, "$1"));
  if (isNaN(d.getTime())) return String(iso).slice(0, 10);
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" });
};

export const AcquistiContatto = ({ email }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!email) return;
    api.get(`/optin/acquisti?email=${encodeURIComponent(email)}`).then((r) => setData(r.data)).catch(() => {});
  }, [email]);
  if (!data || !data.acquisti.length) return null;
  const tot = data.acquisti.reduce((s, a) => s + (parseFloat(a.importo) || 0), 0);
  return (
    <div className="panel" data-testid="acquisti-contatto">
      <h3>🛒 Acquisti dal sito ({data.acquisti.length}) · totale {tot.toFixed(2).replace(".", ",")} €</h3>
      <table style={{ width: "100%" }}>
        <thead><tr><th>Quando</th><th>Strumento</th><th>Importo</th><th>Coupon</th><th>Consenso marketing</th></tr></thead>
        <tbody>
          {[...data.acquisti].reverse().map((a, i) => (
            <tr key={i} data-testid={`acquisto-riga-${i}`}>
              <td style={{ whiteSpace: "nowrap" }}>{itDT(a.at)}</td>
              <td><strong>{a.prodotto}</strong></td>
              <td>{a.importo ? `${a.importo} €` : "—"}</td>
              <td>{a.coupon || "—"}</td>
              <td>{a.consenso_marketing ? "✅ Sì (art. 6.1.a)" : "❌ No — solo transazionale"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AcquistiContatto;
